<template>
  <footer class="estate-administration-cost-calculator-footer">
    <div class="footer-container">
      <div class="d-flex align-center request-column">
        <span
          class="phone-icon d-flex align-center justify-center"
          :style="{ borderColor: whitelabel.colors.primary }"
        >
          <img
            :src="require(`@/assets/old_mutual/icons/phone.svg`)"
            alt="Call us"
          />
        </span>
        <strong class="ml-2"
          >Call us on
          <span :style="{ color: whitelabel.colors.primary }">
            <a :href="`tel:${whitelabel.requestACallTelUrl}`">{{
              whitelabel.requestACallTel
            }}</a>
          </span>
          or</strong
        >
      </div>
      <div class="d-flex align-center">
        <span
          class="request-a-call-button ml-2 mr-2"
          rounded
          outlined
          @click="$emit('requestACall')"
          >request a call</span
        >
      </div>
      <div>
        <strong>for more information</strong>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'CalculatorFooter',
  };
</script>
<style lang="scss" scoped>
  .estate-administration-cost-calculator-footer {
    margin-top: 88px;
    a {
      text-decoration: none !important;
    }
  }

  .footer-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #edeeee;
    padding: 20px 8px;
  }
  small {
    font-size: 6px;
    text-align: right;
    max-width: 255px;
    font-weight: 500;
  }

  .phone-icon {
    border-radius: 50%;
    border: 1px solid;
    width: 20px;
    height: 20px;

    img {
      width: 12px;
      height: 12px;
    }
  }
  .request-a-call-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    height: 32px;
    border-radius: 100px;
    border: 1px solid #dcddde;
    color: #282828;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.4px;
    text-align: center;
    cursor: pointer;
    padding: 8px 14.5px;
  }

  strong {
    font-size: 15px;
    font-weight: 600;
    line-height: 22.5px;
    color: black;
  }

  @media only screen and (min-width: 0px) and (max-width: 679px) {
    .footer-container {
      flex-direction: column;
      gap: 13px;
    }
  }
</style>
